module.exports = __webpack_public_path__ + "img/edit2.dc0a6061.png";